import React from 'react'
import '../App.css'
import Bodyconsolidatedreport from './bodyconsolidatedreport'
export class Bodyappconsolidatedreportbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodyconsolidatedreport/>
            </div>
            
        );
    }
}